import Article from "components/Article";
import { Content } from "components/Content/styles";

function Home() {
  return (
    <Content>
      <Article />
    </Content>
  );
}

export default Home;
